<div
  class="w-full h-12 flex items-center justify-center relative overflow-visible max-xl:bg-white max-xl:shadow-card-lg"
>
  <!-- Centered bar with 70% width and slanted edges -->
  <div
    #tabContainer
    class="w-full xl:w-[70%] h-full relative flex px-sm xl:px-4 flex-col items-center justify-center overflow-visible max-xl:bg-white"
    [class.footer-tab-container--details]="highlightBackground"
  >
    <!-- Slanted trapezoid background using SVG -->
    <!-- <svg class="absolute inset-0 w-full h-full" viewBox="0 0 100 48" preserveAspectRatio="none">
    <path d="M 0 48 L 10 12 Q 12 2, 18 0 L 82 0 Q 88 2, 90 12 L 100 48 Z" fill="white" stroke="none" />
    <defs>
      <filter id="filter0_d_38_2317" x="0" y="0" width="1114.17" height="157" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="-4" />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0901961 0 0 0 0 0.282353 0 0 0 0 0.054902 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_38_2317" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_38_2317" result="shape" />
      </filter>
    </defs>
  </svg> -->
    @if (highlightBackground) {
    <svg
      class="absolute inset-0 hidden w-full h-full footer-tab-svg footer-tab-svg--fill xl:block"
      [style.filter]="'var(--footer-tab-card-shadow)'"
      [attr.viewBox]="getViewBox()"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        [attr.d]="dynamicPath()"
        class="footer-tab-shape footer-tab-shape--details"
      />
    </svg>
    <svg
      class="absolute inset-0 hidden w-full h-full footer-tab-svg footer-tab-svg--details z-[1] xl:block"
      [attr.viewBox]="getViewBox()"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        [attr.d]="dynamicStrokePath()"
        class="footer-tab-border-stroke"
        fill="none"
      />
    </svg>
    } @else {
    <svg
      class="absolute inset-0 hidden w-full h-full footer-tab-svg xl:block"
      [style.filter]="
        'var(--shadow-drop-up, drop-shadow(0px -4px 15px var(--color-shadow)))'
      "
      [attr.viewBox]="getViewBox()"
      preserveAspectRatio="none"
    >
      <path [attr.d]="dynamicPath()" class="footer-tab-shape" />
    </svg>
    }
    <!-- Left arrow button - only show when needed -->
    @if(showNavigation()){
    <button
      type="button"
      (mousedown)="$event.preventDefault()"
      (click)="goToPrevious()"
      [disabled]="!canGoPrevious()"
      class="absolute left-[8%] top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center transition-colors z-20 rounded-full outline-none widget-focus-ring"
      [class.text-slate-400]="canGoPrevious()"
      [class.text-slate-300]="!canGoPrevious()"
      [class.hover:text-slate-600]="canGoPrevious()"
      [class.cursor-not-allowed]="!canGoPrevious()"
      [class.cursor-pointer]="canGoPrevious()"
      aria-label="Previous tabs"
    >
      <i class="pi pi-chevron-left" style="font-size: 12px"></i>
    </button>
    }

    <!-- Right arrow button - only show when needed -->
    @if(showNavigation()){
    <button
      type="button"
      (mousedown)="$event.preventDefault()"
      (click)="goToNext()"
      [disabled]="!canGoNext()"
      class="absolute right-[8%] top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center transition-colors z-20 rounded-full outline-none widget-focus-ring"
      [class.text-slate-400]="canGoNext()"
      [class.text-slate-300]="!canGoNext()"
      [class.hover:text-slate-600]="canGoNext()"
      [class.cursor-not-allowed]="!canGoNext()"
      [class.cursor-pointer]="canGoNext()"
      aria-label="Next tabs"
    >
      <i class="pi pi-chevron-right" style="font-size: 12px"></i>
    </button>
    }
    <div
      #scrollContainer
      (scroll)="handleScroll()"
      class="flex items-center gap-x-xs relative w-full xl:w-[50vw] h-full overflow-x-auto overscroll-x-contain touch-pan-x no-scrollbar scroll-smooth"
      [class.justify-center]="!showNavigation()"
      [class.justify-start]="showNavigation()"
      [class.px-12]="showNavigation()"
    >
      @for (tab of tabs; track tab.id) {
      <div
        class="relative h-full flex items-center shrink-0"
        [attr.data-tab-id]="tab.id"
      >
        <a
          [routerLink]="tab.children?.length ? null : tab.route"
          [queryParams]="tab.queryParams"
          tabindex="0"
          (mousedown)="$event.preventDefault()"
          (click)="onTabClick($event, tab)"
          (keydown.enter)="onTabClick($event, tab)"
          (keydown.space)="onTabClick($event, tab)"
          class="relative flex flex-col items-center justify-center h-full outline-none transition-all duration-200 z-10 w-fit cursor-pointer group no-underline widget-focus-ring rounded"
        >
          <!-- LABEL & SUBLABEL CONTAINER -->
          <div class="flex items-center gap-1.5 px-4 relative z-10">
            <!-- ICON -->
            @if (tab.icon && iconComponents[tab.icon]) {
            <div
              class="flex items-center justify-center w-4 h-4 opacity-70 group-hover:opacity-100 transition-opacity"
              [class.opacity-100]="isActive(tab.id)"
            >
              <ng-container
                *ngComponentOutlet="
                  iconComponents[tab.icon].component;
                  inputs: {
                    startColor: isActive(tab.id)
                      ? 'var(--color-primary-start-color)'
                      : '#94a3b8',
                    endColor: isActive(tab.id)
                      ? 'var(--color-primary-end-color)'
                      : '#94a3b8',
                    width: iconComponents[tab.icon].width,
                    height: iconComponents[tab.icon].height
                  }
                "
              ></ng-container>
            </div>
            }
            <!-- LABEL -->
            <span
              class="tab-label text-xs font-medium transition-all font-semibold whitespace-nowrap pointer-events-none"
              [class.text-gradient-primary]="isActive(tab.id)"
              [attr.data-text]="tab.label | translate"
            >
              {{ tab.label | translate }}
            </span>

            @if (tab.subLabel) {
            <span class="tab-sublabel whitespace-nowrap font-bold">
              {{ tab.subLabel }}
            </span>
            }
          </div>

          <!-- Active border indicator -->
          <div
            class="tab-indicator absolute left-1/2 w-10 h-[3px] rounded-full bg-card-gradient pointer-events-none"
            [class.active]="isActive(tab.id)"
          ></div>
        </a>
        <!-- CUSTOM SUB-MENU MODAL/DROPDOWN -->
        @if (activeSubMenuTabId() === tab.id) {
        <div
          clickOutside
          (clickOutside)="closeSubMenu()"
          class="absolute bottom-[64px] left-1/2 -translate-x-1/2 min-w-[210px] bg-white rounded-xl shadow-card p-2 z-999 border border-black/5 animate-fade-in-up"
        >
          <!-- SUBMENU ITEMS -->
          <div class="flex flex-col gap-1">
            @for (child of tab.children; track child.id) {
            <a
              [routerLink]="child.route"
              [queryParams]="child.queryParams"
              tabindex="0"
              (mousedown)="$event.preventDefault()"
              (click)="selectTab(tab.id); closeSubMenu()"
              (keydown.enter)="selectTab(tab.id); closeSubMenu()"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors no-underline group outline-none widget-focus-ring"
            >
              <div
                class="flex items-center justify-center w-5 h-5 opacity-90 group-hover:opacity-100 transition-opacity"
              >
                <ng-container
                  *ngComponentOutlet="
                    iconComponents[child.iconComponent!].component;
                    inputs: {
                      startColor: 'var(--color-primary-start-color)',
                      endColor: 'var(--color-primary-end-color)',
                      width: iconComponents[child.iconComponent!].width,
                      height: iconComponents[child.iconComponent!].height
                    }
                  "
                ></ng-container>
              </div>
              <span
                class="text-[0.8rem] font-semibold transition-colors"
                style="color: var(--color-gray-text)"
              >
                {{ child.label | translate }}
              </span>
            </a>
            }
          </div>
          <!-- THEME GRADIENT ARROW -->
          <div class="footer-dropdown-arrow"></div>
        </div>
        }
      </div>
      }
    </div>

    <!-- Scroll indicator bar -->
    @if (showNavigation()) {
    <div class="scroller-container">
      <div
        class="scroller-indicator"
        [style.width.%]="20"
        [style.left.%]="scrollPercentage() * 0.8"
      ></div>
    </div>
    }
  </div>
</div>
